import React from "react";

const galleryImages = [
  {
    url: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=1600&q=80",
    alt: "Freshly brewed coffee",
  },
  {
    url: "https://res.cloudinary.com/dri1qrcuu/image/upload/v1756046671/cafe_interior_with_cozy_ambiance_1_glents.jpg",
    alt: "Café interior with cozy ambiance",
  },
  {
    url: "https://images.unsplash.com/photo-1498804103079-a6351b050096?auto=format&fit=crop&w=1600&q=80",
    alt: "Coffee and croissant",
  },
  {
    url: "https://images.unsplash.com/photo-1470337458703-46ad1756a187?auto=format&fit=crop&w=1600&q=80",
    alt: "Latte art close-up",
  },
  {
    url: "https://images.unsplash.com/photo-1442512595331-e89e73853f31?auto=format&fit=crop&w=1600&q=80",
    alt: "People enjoying coffee",
  },
  {
    url: "https://res.cloudinary.com/dri1qrcuu/image/upload/v1756046919/coffee_beans_and_brewing_machine_setup_gy0nep.jpg",
    alt: "Coffee beans and brewing setup",
  },
];

const Gallery = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-stone-50 to-stone-100 dark:from-stone-900 dark:to-stone-950">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <h2 className="text-3xl font-bold text-center text-stone-800 dark:text-stone-100 mb-12">
          Our <span className="text-amber-600">Gallery</span>
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {galleryImages.map((img, index) => (
            <div
              key={index}
              className="overflow-hidden rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300"
            >
              <img
                src={img.url}
                alt={img.alt}
                className="w-full h-64 object-cover transform hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
